<template>
  <v-dialog v-model="dialog" fullscreen>
    <v-toolbar color="primary">
      <v-spacer></v-spacer>
      <v-btn icon flat @click="close">
        <v-icon color="white">close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card>
      <v-container>
        <v-card-title>
          <span class="headline">Merge Jobs</span>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex class="xs5">
              <v-card>
                <v-card-title>
                  Base Job
                </v-card-title>
                <v-card-text>
                  <template v-if="retreivedJobs[0]">
                    <p>Products: <strong>{{retreivedJobs[0].products ? retreivedJobs[0].products.length : 0}}</strong></p>
                    <p>Completed Photos & Notes: <v-icon>{{completedJobs[0] ? 'check' : 'close'}}</v-icon></p>
                    <p>Completed Documents: <strong v-if="retreivedJobs[0].completedDocs">{{retreivedJobs[0].completedDocs.length}} docs</strong><strong v-else>0 docs</strong></p>
                    <p>Status: <strong>{{retreivedJobs[0].Status|statusFilter}}</strong></p>
                    <p>Completed date: <strong>{{retreivedJobs[0].CompletedDate}}</strong></p>
                    <p>Job No: <strong>{{retreivedJobs[0].JobNo}}</strong></p>
                    <p>Project ID: <strong>{{retreivedJobs[0].Project}}</strong></p>
                  </template>
                  <v-progress-linear v-else :indeterminate="true"></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex class="xs2 text-xs-center">
              <v-btn style="margin-top: 100px;" @click="swapBaseJob()" icon><v-icon x-large>mdi-swap-horizontal</v-icon></v-btn>
            </v-flex>
            <v-flex class="xs5">
              <v-card>
                <v-card-title>
                  Job to merge from
                </v-card-title>
                <v-card-text>
                  <template v-if="retreivedJobs[1]">
                    <p>Products: <strong>{{retreivedJobs[1].products ? retreivedJobs[1].products.length : 0}}</strong></p>
                    <v-checkbox
                      height="0"
                      v-model="mergeCompletedJob"
                    >
                      <template v-slot:label>
                        <div>
                          Completed Images & Notes: <v-icon>{{completedJobs[1] ? 'check' : 'close'}} docs</v-icon>
                        </div>
                      </template>
                    </v-checkbox>
                    <v-checkbox
                      height="0"
                      v-model="mergedJobMap.completedDocs"
                    >
                      <template v-slot:label>
                        <div>
                          Completed Documents: <strong>{{retreivedJobs[1].completedDocs ? retreivedJobs[1].completedDocs.length : 0 }} docs</strong>
                        </div>
                      </template>
                    </v-checkbox>
                    <v-checkbox
                      height="0"
                      v-model="mergedJobMap.Status"
                    >
                      <template v-slot:label>
                        <div>
                          Status: <strong>{{retreivedJobs[1].Status|statusFilter}}</strong>
                        </div>
                      </template>
                    </v-checkbox>
                    <v-checkbox
                      height="0"
                      v-model="mergedJobMap.CompletedDate"
                    >
                      <template v-slot:label>
                        <div>
                          Completed Date: <strong>{{retreivedJobs[1].CompletedDate}}</strong>
                        </div>
                      </template>
                    </v-checkbox>
                    <v-checkbox
                      height="0"
                      :label="'JobNo ' + retreivedJobs[1].JobNo"
                      v-model="mergedJobMap.JobNo"
                    >
                      <template v-slot:label>
                        <div>
                          Job No: <strong>{{retreivedJobs[1].JobNo}}</strong>
                        </div>
                      </template>
                    </v-checkbox>
                    <v-checkbox
                      height="0"
                      v-model="mergedJobMap.Project"
                    >
                      <template v-slot:label>
                        <div>
                          Project ID: <strong>{{retreivedJobs[1].Project}}</strong>
                        </div>
                      </template>
                    </v-checkbox>
                  </template>
                  <v-progress-linear v-else :indeterminate="true"></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex class="xs12 text-xs-center">
              <v-icon x-large>mdi-source-fork</v-icon>  
            </v-flex>
            <v-flex class="xs12">
              <v-card>
                <v-card-title>
                  Merged Job
                </v-card-title>
                <v-card-text>
                  <template v-if="mergedJob">
                    <p>Products: <strong>{{mergedJob.products ? mergedJob.products.length : 0}}</strong></p>
                    <p>Completed Photos & Notes: <v-icon>{{completedJobs[mergeCompletedJob ? 1 : 0] ? 'check' : 'close'}}</v-icon></p>
                    <p>Completed Documents: <strong v-if="mergedJob.completedDocs">{{mergedJob.completedDocs.length}} docs</strong><strong v-else>0 docs</strong></p>
                    <p>Status: <strong>{{mergedJob.Status|statusFilter}}</strong></p>
                    <p>Completed date: <strong>{{mergedJob.CompletedDate}}</strong></p>
                    <p>Job No: <strong>{{mergedJob.JobNo}}</strong></p>
                    <p>Project ID: <strong>{{mergedJob.Project}}</strong></p>
                    <v-checkbox
                      v-model="confirmMerge"
                      label="Please confirm you have checked the merged job is correct. Clicking 'Merge' will overwrite both jobs with the details shown above."
                    />
                    <v-btn :loading="merging" color="primary" :disabled="!confirmMerge" @click="mergeJobs">Merge</v-btn>
                  </template>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { updateAuditLog, fireStore } from '../../firebase'
export default {
  props: ['jobs', 'openDialog'],
  data () {
    return {
      merging: false,
      dialog: false,
      retreivedJobs: [],
      completedJobs: [],
      mergeCompletedJob: true,
      mergedJobMap: {
        JobNo: false,
        Project: false,
        completedDocs: true,
        CompletedDate: true,
        Status: true
      },
      confirmMerge: false
    }
  },
  filters: {
    statusFilter (val) {
      switch (val) {
        case 0:
          return 'Not Started'
        case 1:
          return 'Issue'
        case 2:
          return 'Completed'
        case 3:
          return 'Cubo Approved'

        default:
          return 'Not Started'
      }
    }
  },
  watch: {
    openDialog (val) {
      this.dialog = val
      if (val) {
        this.fetchJobs()
      }
    },
    dialog (val) {
      if (!val) {
        this.$emit('update:mergeJobsDialog', false)
      }
    }
  },
  computed: {
    userData () {
      return this.$store.getters.userData
    },
    mergedJob () {
      if (this.retreivedJobs.length < 2) {
        return {}
      }
      let propsToMerge = {...this.mergedJobMap}
      let mergedJob = JSON.parse(JSON.stringify(this.retreivedJobs[0]))

      for (let prop in propsToMerge) {
        if (propsToMerge[prop]) {
          if (this.retreivedJobs[1][prop]) {
            mergedJob[prop] = this.retreivedJobs[1][prop]
          }
        }
      }

      if (this.retreivedJobs[1].products) {
        if (!mergedJob.products) {
          mergedJob.products = this.retreivedJobs[1].products
        } else {
          for (let p of this.retreivedJobs[1].products) {
            if (mergedJob.products.indexOf(p) === -1) {
              mergedJob.products.push(p)
            }
          }
        }
      }

      if (this.retreivedJobs[1].templates) {
        if (!mergedJob.templates) {
          mergedJob.templates = this.retreivedJobs[1].templates
        } else {
          for (let t of this.retreivedJobs[1].templates) {
            if (mergedJob.templates.indexOf(t) === -1) {
              mergedJob.templates.push(t)
            }
          }
        }
      }

      if (this.retreivedJobs[1].devicesInstalled) {
        if (!mergedJob.devicesInstalled) {
          mergedJob.devicesInstalled = this.retreivedJobs[1].devicesInstalled
        } else {
          for (let d of this.retreivedJobs[1].devicesInstalled) {
            if (mergedJob.devicesInstalled.indexOf(d) === -1) {
              mergedJob.devicesInstalled.push(d)
            }
          }
        }
      }

      mergedJob.finance = {...mergedJob.finance, ...this.retreivedJobs[1].finance}
      mergedJob.extras = {...mergedJob.extras, ...this.retreivedJobs[1].extras}

      return mergedJob
    }
  },
  methods: {
    mergeJobs () {
      this.merging = true
      updateAuditLog('update', 'mergeJobs', this.userData, this.jobs[0].JobNo, this.jobs[0].Project, 'merged job with ' + this.jobs[1].JobNo, null, this.jobs[0].Customer)
      fireStore.collection('Jobs').doc(this.jobs[0].id).collection('preMergeJobs').add(
        {0: this.retreivedJobs[0], 1: this.retreivedJobs[1]}
      )
      .then(() => {
        return fireStore.collection('Jobs').doc(this.jobs[0].id).update(
          this.mergedJob
        )
      })
      .then(() => {
        if (this.mergeCompletedJob && this.completedJobs[1]) {
          this.completedJobs[1].JobNo = this.mergedJob.JobNo
          return fireStore.collection('Jobs').doc(this.jobs[0].id).collection('CompletedJobs').add(
            this.completedJobs[1]
          )
        } else {
          return true
        }
      })
      .then(() => {
        console.log('safe to remove original')
        return fireStore.collection('Jobs').doc(this.jobs[1].id).delete()
      })
      .then(() => {
        this.merging = false
        this.close()
      })
      .catch(error => {
        alert('something went wrong')
        console.log(error)
        this.merging = false
      })
    },
    fetchJobs () {
      this.completedJobs = []
      this.retreivedJobs = []
      fireStore.collection('Jobs').doc(this.jobs[0].id).get()
        .then(doc => {
          this.$set(this.retreivedJobs, 0, doc.data())
        })
      fireStore.collection('Jobs').doc(this.jobs[1].id).get()
        .then(doc => {
          this.$set(this.retreivedJobs, 1, doc.data())
        })
      fireStore.collection('Jobs').doc(this.jobs[0].id).collection('CompletedJobs').get()
        .then(snap => {
          snap.forEach(doc => {
            console.log(doc.data())
            console.log('test')
            this.$set(this.completedJobs, 0, doc.data())
          })
        })
      fireStore.collection('Jobs').doc(this.jobs[1].id).collection('CompletedJobs').get()
        .then(snap => {
          snap.forEach(doc => {
            console.log(doc.data())
            this.$set(this.completedJobs, 1, doc.data())
          })
        })
    },
    swapBaseJob () {
      let temp = this.retreivedJobs[0]
      this.$set(this.retreivedJobs, 0, this.retreivedJobs[1])
      this.$set(this.retreivedJobs, 1, temp)
      let ctemp = this.completedJobs[0]
      this.$set(this.completedJobs, 0, this.completedJobs[1])
      this.$set(this.completedJobs, 1, ctemp)
    },
    close () {
      this.dialog = false
    },
    vehicleRegFromID (id) {
      const index = this.vehicles.findIndex(vehicle => {
        return vehicle.key === id
      })
      if (index > -1) {
        if (this.vehicles[index]['VehicleReg']) {
          return this.vehicles[index]['VehicleReg']
        } else if (this.vehicles[index]['friendlyId']) {
          return this.vehicles[index]['friendlyId']
        }
      } else {
        return ''
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// MergeJobsDialog.vue?4f98b09e